import { action } from 'satcheljs';
// IMPORTANT: Do not add any other code here. This is only to define the action. Any orchestrator should be in a different place.
/**
 * Action called whenever an attachment is deleted
 * @param parentItemId The id of the parent item from which attachment is deleted
 * @param attachmentId The id of the deleted attachment
 * @param attachment The attachment that was deleted
 */
export default action('ON_ATTACHMENT_DELETED', function (parentItemId, attachmentId, attachment) {
    return {
        parentItemId: parentItemId,
        attachmentId: attachmentId,
        attachment: attachment,
    };
});
//# sourceMappingURL=onAttachmentDeleted.js.map